export default __webpack_public_path__ + "static/PC-singapore-1-a86809816c5883814780697d577e9e53.svg";